// external imports
import { grey4 } from 'quark-web/styles'

export default {
    resultHeader: {
        fontWeight: '500',
        marginBottom: 6
    },
    resultCount: {
        marginBottom: 20,
        color: grey4
    },
    query: {
        fontWeight: '600'
    }
}



// WEBPACK FOOTER //
// ./src/views/Search/styles.js